import type { ITool } from './ITool';

class ToolManager {
  private tools = new Map<string, ITool>();
  private _active: ITool | null = null;
  register(tool: ITool) { this.tools.set(tool.name, tool); }
  unregister(name: string) { this.tools.delete(name); }
  setActive(name: string | null) {
    if (this._active?.onDeactivate) this._active.onDeactivate();
    this._active = name ? this.tools.get(name) ?? null : null;
    if (this._active?.onActivate) this._active.onActivate();
  }
  get active(): ITool | null { return this._active; }
}
export const toolManager = new ToolManager();